import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f240696e")

_pushScopeId("data-v-f240696e")
const _hoisted_1 = { class: "active-pages" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "active-pages-news" }, null, -1)
const _hoisted_4 = { class: "active-pages-category" }
const _hoisted_5 = { class: "news-tip" }
const _hoisted_6 = { class: "active-pages-list-item-title" }
const _hoisted_7 = {
  key: 0,
  class: "active-pages-list-item-time"
}
const _hoisted_8 = {
  key: 1,
  class: "active-pages-list-item-time"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "active-pages-hot-tip" }, "热门", -1)
const _hoisted_10 = { class: "active-pages-hot-list" }
const _hoisted_11 = { class: "active-pages-hot-list-item-title" }
const _hoisted_12 = { class: "active-pages-hot-list-item-time" }
const _hoisted_13 = { class: "active-pages-list-pagination" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withId(() => [
          _createVNode(_component_el_col, {
            class: "active-pages-list",
            md: 12,
            sm: 24,
            xs: 24
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabList, (item, i) => {
                  return (_openBlock(), _createBlock("p", {
                    key: i,
                    onClick: ($event: any) => (_ctx.changeTab(item.value, i)),
                    class: ["active-pages-category-item", [_ctx.active === i ? 'active-pages-category-active' : '']]
                  }, _toDisplayString(item.label), 11, ["onClick"]))
                }), 128))
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.newsList, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  md: 12,
                  sm: 24,
                  xs: 24,
                  class: "active-pages-list-item",
                  key: i,
                  onClick: ($event: any) => (_ctx.next(item.id))
                }, {
                  default: _withId(() => [
                    _createVNode("i", _hoisted_5, _toDisplayString(item.typeStr || '活动'), 1),
                    _createVNode("img", {
                      src: item.image,
                      alt: "",
                      class: "active-pages-list-item-img"
                    }, null, 8, ["src"]),
                    _createVNode("p", _hoisted_6, _toDisplayString(item.title || item.name), 1),
                    (item.publishDateStr)
                      ? (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(item.publishDateStr), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(item.startDateStr), 1))
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            md: 2,
            sm: 24,
            xs: 24
          }),
          _createVNode(_component_el_col, {
            class: "active-pages-hot",
            md: 10,
            sm: 24,
            xs: 24
          }, {
            default: _withId(() => [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hotList, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "active-pages-hot-list-item",
                    key: item.id,
                    onClick: ($event: any) => (_ctx.next(item.id))
                  }, [
                    _createVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                    _createVNode("div", _hoisted_12, _toDisplayString(item.publishDateStr), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          background: "",
          total: _ctx.newsTotal,
          "page-size": _ctx.params.size,
          "current-page": _ctx.params.current,
          onCurrentChange: _ctx.onCurrentChange
        }, null, 8, ["total", "page-size", "current-page", "onCurrentChange"])
      ])
    ])
  ]))
})